const ACOES = {
    INSERIR: 2,
    ALTERAR: 3,
    EXCLUIR: 4,
    CONSULTAR: 5,
    VISUALIZAR: 6,
    CHAMAR_PAINEL: 9,
    ALTERAR_STATUS_AGENDA: 11,
}

const SERVICE = {
    DOCWAGE: process.env.REACT_APP_BATCH_OF_GUIDES_API + '/Processor/add',
    ENGINE_INTEGRATION: process.env.REACT_APP_ENGINE_INTEGRATION_API + '/Processor/add',
    BATCH_OF_GUIDES: process.env.REACT_APP_BATCH_OF_GUIDES_API + '/Processor/add-batch-of-guides',
    BATCH_UPDATE_STATUS: process.env.REACT_APP_BATCH_OF_GUIDES_API + '/Processor/batch-update-status'
}

const MODULO = {
    '/controleacesso/usuario': 1,
    '/controleacesso/usuariopaginacao/0': 1,
    '/controleacesso/grupo': 2,
    '/controleacesso/grupopaginacao/0': 2,
    '/controleacesso/modulo': 3,
    '/controleacesso/auditoria': 5,
    '/controleacesso/auditoria/0': 5,
    '/atendimento/beneficiario': 6,
    '/atendimento/beneficiariopaginacao/0': 6,
    '/faturamento/cooperadopfpaginacao/0': 7,
    '/faturamento/cooperadopf': 7,
    '/faturamento/cooperadopjpaginacao/0': 8,
    '/faturamento/cooperadopj': 8,
    '/atendimento/prontuariopaginacao/0': 9,
    '/atendimento/prontuario': 9,
    '/atendimento/agenda': 10,
    '/atendimento/bloqueioagenda': 10,
    '/atendimento/prestador': 11,
    '/atendimento/prestadorpaginacao/0': 11,
    '/atendimento/prestadorcbos': 12,
    '/atendimento/prestadorcbospaginacao/0': 12,
    '/atendimento/prestadorconselhoprof': 13,
    '/atendimento/prestadorconselhoprofpaginacao/0': 13,
    '/atendimento/agendastatus': 11
}

const AGENDA_STATUS = {
    AGENDADO: 1,
    CONFIRMADO: 2,
    EM_ATENDIMENTO: 3,
    FINALIZADO: 4,
    EM_ESPERA: 5,
    REAGENDADO: 6,
    CANCELADO: 7
}

export { ACOES, MODULO, SERVICE, AGENDA_STATUS }